(function () {
  const mainProduct = document.querySelector('.product-information');
  if (!mainProduct) return;

  const productID = mainProduct.dataset.product_id;


  document.addEventListener('DOMContentLoaded', async () => {
    const variantsInventoryLevels = await getVariantsInventoryLevels(productID);
    const product = await getProduct(productID);
    productAppointo();

    const targetNode = document.querySelector("#main-product-cart__holder.add_to_cart_holder");
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          productAppointo();
        } else if (mutation.type === "attributes" && mutation.target.classList.contains('.appointo-custom-styles')) {
          observer.disconnect();
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    const productAndVariantsInventoryOnLoad = new CustomEvent('productAndVariantsInventoryOnLoad', { detail: { product, variantsInventoryLevels } });
    document.dispatchEvent(productAndVariantsInventoryOnLoad);
  });

  function productAppointo() {
    const appointoBtn = mainProduct.querySelector('#appointo-btn');
    if (appointoBtn === null || appointoBtn === undefined) {
      return;
    }
    if (appointoBtn.classList.contains('d-none')) appointoBtn.classList.remove('d-none');
    appointoBtn.classList.add('appointo-custom-styles');
    appointoBtn.closest('div').addEventListener('mouseover', function () {
      appointoBtn.setAttribute('style', 'background:black !important; color:white !important');
    })
    appointoBtn.closest('div').addEventListener('mouseleave', function () {
      appointoBtn.setAttribute('style', 'background:white !important; color:black !important');
    })
    appointoBtn.nextElementSibling.classList.add('d-none');
    if (document.querySelector('fieldset .variant-picker')) {
      document.querySelectorAll('fieldset .variant-picker').forEach(el => el.classList.add('d-none'));
    }
  }


  document.addEventListener("product:variant-change", async function (e) {
    const variantsInventoryLevels = await getVariantsInventoryLevels(productID);

    const product = await getProduct(productID);
    const productOnChange = new CustomEvent('productOnChange', { detail: { product, variantsInventoryLevels } });
    document.dispatchEvent(productOnChange);
  });


  async function getVariantsInventoryLevels(productID) {
    if (!productID) return;

    const domainName = 'https://netlify.blacklemon.dk'
    const storeName = 'plaza-ure-smykker'
    const APIURL = `${domainName}/.netlify/functions/getProductInventoryLevels?store=${storeName}&prodId=${productID}`
    try {
      const response = await fetch(APIURL)
      if (response?.ok) return await response.json()
    } catch (error) {
      console.log('There was an error', error)
    }
  }

  if (document.querySelector('.notify-me-btn')) {
    document.querySelector('.notify-me-btn').addEventListener('click', function (el) {
      productBackInStockMain();
    })
  }


  function productBackInStockMain() {
    const targetNode = document.querySelector('#klaviyo-bis-iframe');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          productBackInStockModal()
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config)
  }

  function productBackInStockModal() {
    const envelopeIcon = ` <svg xmlns="http://www.w3.org/2000/svg" width="32" height="23" viewBox="0 0 32 23" fill="none">
    <path d="M29.7143 0H2.28571C1.67951 0 1.09812 0.242321 0.66947 0.673654C0.240816 1.10499 0 1.69 0 2.3V20.7C0 21.31 0.240816 21.895 0.66947 22.3263C1.09812 22.7577 1.67951 23 2.28571 23H29.7143C30.3205 23 30.9019 22.7577 31.3305 22.3263C31.7592 21.895 32 21.31 32 20.7V2.3C32 1.69 31.7592 1.10499 31.3305 0.673654C30.9019 0.242321 30.3205 0 29.7143 0ZM27.2 2.3L16 10.097L4.8 2.3H27.2ZM2.28571 20.7V3.3465L15.3486 12.443C15.5399 12.5765 15.7672 12.6481 16 12.6481C16.2328 12.6481 16.4601 12.5765 16.6514 12.443L29.7143 3.3465V20.7H2.28571Z" fill="black"/>
  </svg>`;
    const iframeBody = document.querySelector('#klaviyo-bis-iframe').contentWindow.document.body;
    const successButton = iframeBody.querySelector('button.btn-success');
    if (successButton) {
      const successButtonText = successButton?.innerText
      successButton.innerHTML = envelopeIcon + '<span>' + successButtonText + '</span>';
    }

    const closeKlaviyo = iframeBody.querySelector('.klaviyo-bis-close');

    if (closeKlaviyo) {
      closeKlaviyo.innerHTML = `
        <svg class='close klaviyo-bis-close' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M15 15L3 3M15 3L3 15" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    `;
    }
    successButton.addEventListener('click', function (el) {
      const targetNode = iframeBody.querySelector('#completed_message');
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "attributes") {
            productBackInStockSubmitted(iframeBody, successButton, envelopeIcon)
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config)
    });
  }

  function productBackInStockSubmitted(iframeBody, successButton, envelopeIcon) {
    if (successButton) {
      if (iframeBody.querySelector('#container p')) iframeBody.querySelector('#container p').remove();
      if (iframeBody.querySelector('#container #email')) iframeBody.querySelector('#container #email').remove();
      if (iframeBody.querySelector('#container #variant_select')) iframeBody.querySelector('#container #variant_select').remove();

      if (iframeBody.querySelector('#container #newsletter_subscription')) iframeBody.querySelector('#container #newsletter_subscription').remove()
      if (!iframeBody.querySelector('.feedback-envelope-icon')) {
        const feeedbackIcon = document.createElement('div');
        feeedbackIcon.classList.add('feedback-envelope-icon');
        feeedbackIcon.innerHTML = envelopeIcon;
        iframeBody.querySelector('#completed_message div').parentNode.insertBefore(feeedbackIcon, iframeBody.querySelector('#completed_message div'));
      }
    }
  }




  async function getProduct(productID) {
    if (!productID) return;

    const domainName = 'https://netlify.blacklemon.dk'
    const storeName = 'plaza-ure-smykker'
    const APIURL = `${domainName}/.netlify/functions/getProduct?store=${storeName}&id=${productID}`
    try {
      const response = await fetch(APIURL);
      if (response?.ok) return await response.json()
    } catch (error) {
      console.log('There was an error', error)
    }
  }
})();